import React from 'react';
import { Text, Stack, ControlLink } from '@moda/om';
import { hrefFor } from '../../../../routers';
import { ShippingStatus } from '../../../../hooks/useOrder';

interface Props {
  shippingStatus: ShippingStatus;
}

export const OrderDetailsShippingStatus: React.FC<Props> = ({ shippingStatus }) => {
  if (typeof shippingStatus === 'string' && shippingStatus != 'Ships in 3-5 days') {
    return (
      <Stack justifyContent="center" space={2}>
        <Text treatment="body2" color="cement">
          Status
        </Text>
        <Text>{shippingStatus}</Text>
      </Stack>
    );
  }

  if (typeof shippingStatus != 'string' && shippingStatus?.reason) {
    return (
      <Stack space={4}>
        <Stack space={1}>
          <Text treatment="body2" color="cement">
            Reason:
          </Text>

          <Text>{shippingStatus.reason}</Text>
        </Stack>

        <Stack space={1}>
          <Text treatment="body2" color="cement">
            Refund To:
          </Text>

          <Text> {shippingStatus.return_method}</Text>
        </Stack>

        {shippingStatus?.tracking_number && (
          <Stack alignItems="flex-start" space={1}>
            <Text treatment="body2" color="cement">
              Track Return:
            </Text>

            <ControlLink
              href={shippingStatus?.tracking_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {shippingStatus?.tracking_number}
            </ControlLink>
          </Stack>
        )}

        <Stack alignItems="flex-start" space={1}>
          <Text treatment="body2" color="cement">
            Request Number:
          </Text>

          <ControlLink
            to={hrefFor.ReturnSummaryPage({
              shipmentNumber: shippingStatus.request_number
            })}
          >
            #{shippingStatus.request_number}
          </ControlLink>
        </Stack>
      </Stack>
    );
  }

  return null;
};
